/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Everyone_On_SquadInputs */

const th_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เล่นทุกคนอยู่ในทีมนี้แล้ว`)
};

const en_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every player is already on this squad.`)
};

const ja_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全選手がすでにメンバーに入っています。`)
};

const zh_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有球员都已在此阵容中。`)
};

const es_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los jugadores ya están en esta plantilla.`)
};

const pt_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os jogadores já estão neste elenco.`)
};

const id_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua pemain sudah ada di skuad ini.`)
};

const fr_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les joueurs sont déjà dans cet effectif.`)
};

const tl_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasa squad na ang lahat ng manlalaro.`)
};

const vi_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi cầu thủ đều đã có trong đội hình này.`)
};

const ko_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 선수가 이미 이 선수단에 있습니다.`)
};

const de_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Spieler sind bereits in diesem Kader.`)
};

const ru_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все игроки уже в этом составе.`)
};

const tr_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm oyuncular zaten bu kadroda.`)
};

const it_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i giocatori sono già in questa rosa.`)
};

const pl_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszyscy zawodnicy są już w tym składzie.`)
};

const uk_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі гравці вже в цьому складі.`)
};

const hi_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी खिलाड़ी पहले से इस टीम में हैं।`)
};

const ar_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل اللاعبين موجودون في هذه التشكيلة.`)
};

const ms_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua pemain sudah ada dalam skuad ini.`)
};

const bn_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব খেলোয়াড় ইতিমধ্যেই এই দলে আছেন।`)
};

const zh_tw2_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有球員都已在這份名單中。`)
};

const zh_hk2_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有球員都已在這份名單中。`)
};

const ur_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمام کھلاڑی پہلے ہی اس اسکواڈ میں ہیں۔`)
};

const fa_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همهٔ بازیکنان از پیش در این فهرست تیم هستند.`)
};

const sw_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachezaji wote tayari wapo kwenye kikosi hiki.`)
};

const nl_everyone_on_squad = /** @type {(inputs: Everyone_On_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle spelers zitten al in deze selectie.`)
};

/**
* | output |
* | --- |
* | "Every player is already on this squad." |
*
* @param {Everyone_On_SquadInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const everyone_on_squad = /** @type {((inputs?: Everyone_On_SquadInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Everyone_On_SquadInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_everyone_on_squad(inputs)
	if (locale === "ja") return ja_everyone_on_squad(inputs)
	if (locale === "zh") return zh_everyone_on_squad(inputs)
	if (locale === "es") return es_everyone_on_squad(inputs)
	if (locale === "pt") return pt_everyone_on_squad(inputs)
	if (locale === "id") return id_everyone_on_squad(inputs)
	if (locale === "fr") return fr_everyone_on_squad(inputs)
	if (locale === "tl") return tl_everyone_on_squad(inputs)
	if (locale === "vi") return vi_everyone_on_squad(inputs)
	if (locale === "ko") return ko_everyone_on_squad(inputs)
	if (locale === "de") return de_everyone_on_squad(inputs)
	if (locale === "ru") return ru_everyone_on_squad(inputs)
	if (locale === "tr") return tr_everyone_on_squad(inputs)
	if (locale === "it") return it_everyone_on_squad(inputs)
	if (locale === "pl") return pl_everyone_on_squad(inputs)
	if (locale === "uk") return uk_everyone_on_squad(inputs)
	if (locale === "hi") return hi_everyone_on_squad(inputs)
	if (locale === "ar") return ar_everyone_on_squad(inputs)
	if (locale === "ms") return ms_everyone_on_squad(inputs)
	if (locale === "bn") return bn_everyone_on_squad(inputs)
	if (locale === "zh-TW") return zh_tw2_everyone_on_squad(inputs)
	if (locale === "zh-HK") return zh_hk2_everyone_on_squad(inputs)
	if (locale === "ur") return ur_everyone_on_squad(inputs)
	if (locale === "fa") return fa_everyone_on_squad(inputs)
	if (locale === "sw") return sw_everyone_on_squad(inputs)
	if (locale === "nl") return nl_everyone_on_squad(inputs)
	return en_everyone_on_squad(inputs)
});